module.exports = __webpack_public_path__ + "img/growth-active.e5395a66.svg";